// Los trozos que siempre se leen de izquierda a derecha, aunque la página esté en árabe (dir="rtl"):
// teléfonos, horas, correos, direcciones web. Sin aislamiento, el algoritmo bidi del navegador manda el
// « + » al final y « +97154000333 » se lee « 97154000333+ ». `<bdi dir="ltr">` aísla el trozo del texto
// de alrededor y le fija la dirección: en una página LTR no cambia nada.
import type { ComponentProps } from "react";
import { cn } from "@responia/ui/lib/utils";

export function Ltr({ className, ...props }: ComponentProps<"bdi">) {
  return <bdi dir="ltr" className={cn("[unicode-bidi:isolate]", className)} {...props} />;
}
